import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import H1 from '../../components/H1';
import P from '../../components/Paragraph';

import { Container } from './styles';

const AboutUs = () => {
  const { t } = useTranslation('footer');

  return (
    <Container>
      <Helmet>
        <title>{t('aboutUs')}</title>
      </Helmet>
      <div className="row mb60 mt70">
        <div className="col-sm-12">
          <H1 className="mb30">
            <Trans ns="rules" i18nKey="aboutUs.mainTitle">Discover Sportya</Trans>
          </H1>
          <P large className="mb40">
            <Trans ns="rules" i18nKey="aboutUs.mainDescription">
              After more than 12 years of experience within the <strong>Tenis Partener</strong> community, launched
              in 2009, we are opening a new chapter. <strong>Sportya</strong> is not just a platform or a project –
              it is a <strong>global community</strong> for those who love movement, fair competition, and an
              active lifestyle.<br /><br />

              <strong>Sportya is the place you want to be.</strong><br />
              A space where we connect through sport, regardless of age, gender, culture, or beliefs. A space where
              we inspire each other, train together, support one another, and grow as a community. Here, we all speak
              the same language: <strong>the language of sport</strong> .<br /><br />

              If <strong>Tenis Partener</strong> was created to unite amateur tennis players in Romania,&nbsp;
              <strong>Sportya</strong> expands this vision internationally. The platform has been rebuilt from scratch,
              with a strong focus on <strong>technology, accessibility</strong>, and <strong>long-term growth</strong>.
              In the coming years, Sportya will integrate more sports, expanding the community and the opportunities
              for every member.<br /><br />

              <strong>Sportya</strong> is a return to core values: <strong>innovation, teamwork</strong>, and a
              shared <strong>passion for sport</strong>. Just like we did in 2009, we believe sport has the power to
              bring people together, change perspectives, and build lasting connections.<br /><br />

              <strong>Our vision?</strong><br />
              A world where sport becomes a natural part of everyday life. Where children grow up active, adults
              stay engaged, and multi-sport events bring people together from every corner of the globe.<br />

              Everything we do is guided by a simple belief: <strong>sport creates real and lasting connections</strong>
              . And Sportya is the bridge between people, passion, and performance.<br /><br />

              <strong>Welcome to Sportya – an active, vibrant, and inclusive community.</strong><br /><br />

              <strong>MEDIA PRODUCTION GROUP SRL</strong><br />
              HQ: Campina, Str. Marasesti Nr 15B, Ap. 4, Jud. Prahova, cod postal 105600<br />
              Reg. Com.: J29/1130/1997<br />
              CIF: RO 9815911<br />
              Email: corporate@mpg.com.ro<br /><br />

              <strong>ASOCIAȚIA CLUBUL SPORTIV MPG</strong><br />
              HQ: Campina, Str. Marasesti Nr 15B, Ap. 4, Jud. Prahova, cod postal 105600<br />
              Reg. at Judecatoria Sectorului 2 cu nr. 94/22.07.2015<br />
              CIF: 34882970<br />
              Sports ID Certificate nr. 0076158/25.01.2016, reg. in sports Registry with nr. B/A2/00019/2016<br />
              Email: events@mpg.com.ro<br />
            </Trans>
          </P>
        </div>
      </div>
    </Container>
  );
};

export default AboutUs;
